import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["position"];

  number() {
    this.positionTargets.forEach((input, index) => (input.value = index));
  }
}
